export default __webpack_public_path__ + "static/media/1.eb97d1c3.jfif";